import { request } from '@/lib/apiClient';
import { endpoints } from '@/features/endpoints';
import type { AdminAnalytics } from '@/types/domain';

/**
 * `GET /admin/analytics`.
 *
 * One request paints the whole dashboard - KPIs, both time series, the role
 * split and the needs-attention lists. Splitting it into five would mean five
 * round trips and five independent failure states on a screen that is either
 * useful as a whole or not at all.
 */
export function fetchAnalytics(signal?: AbortSignal): Promise<AdminAnalytics> {
  return request<AdminAnalytics>(endpoints.analytics, signal ? { signal } : {});
}
